import { CreatePricelistServiceProviderRequestDTO, PricelistResponseDTO } from 'typings/dto/pricelist';
import ModelActionsService from '../ModelActionsService';
import IPricelistServiceProviderActionsService from './IPricelistServiceProviderActionsService';

export default class PricelistServiceProviderActionsServiceImpl
  extends ModelActionsService<Pricelist.ServiceProvider, CreatePricelistServiceProviderRequestDTO, PricelistResponseDTO.ServiceProvider>
  implements IPricelistServiceProviderActionsService {}
